/* TÖSTI UI: hover-billede på produktkort (lazy, kun mus, samme farvevariant).
   28-09-2026: Den gamle cookie-styling (stor boks midt på skærmen + scroll-lås) er fjernet herfra.
   Cookie-banneret styles nu KUN af snippets/tosti-cookie-bar.liquid (lav bjælke i bunden), så de to ikke kæmper mod hinanden. */
(function(){
  'use strict';
  var canHover = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;
  var cache = {};
  function linkInfo(root){
    var a = root.querySelector('a[href*="/products/"]');
    if(!a) return null;
    var href = a.getAttribute('href') || '';
    var m = /\/products\/([^\/?#]+)/.exec(href);
    if(!m) return null;
    var v = /[?&]variant=(\d+)/.exec(href);
    return {handle: m[1], variant: v ? v[1] : null};
  }
  function product(handle){
    if(!cache[handle]){
      cache[handle] = fetch('/products/' + handle + '.js', {credentials:'same-origin'})
        .then(function(r){ return r.ok ? r.json() : null; })
        .catch(function(){ return null; });
    }
    return cache[handle];
  }
  /* Billede nr. 2 i SAMME farve: billedet lige efter varianten's eget hovedbillede */
  function pick(p, variantId, primarySrc){
    if(!p || !p.images || p.images.length < 2) return null;
    var imgs = p.images, idx = 0;
    var v = null, i;
    if(variantId){ for(i = 0; i < p.variants.length; i++){ if(String(p.variants[i].id) === variantId){ v = p.variants[i]; break; } } }
    if(!v) v = p.variants[0];
    if(v && v.featured_image && v.featured_image.position) idx = v.featured_image.position - 1;
    var next = imgs[idx + 1] || imgs[idx - 1] || null;
    if(!next) return null;
    var base = function(u){ return String(u).split('?')[0]; };
    if(primarySrc && base(next) === base(primarySrc)) next = imgs[idx + 2] || null;
    return next;
  }
  function sized(url){ return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=680'; }
  function attach(wrap){
    if(wrap.__tosti2) return;
    wrap.__tosti2 = 1;
    var primary = wrap.querySelector('img.product-item-image, img');
    if(!primary) return;
    if(wrap.querySelector('img.product-item-image--secondary')) return;
    var info = linkInfo(wrap.closest('.product-item, article') || wrap);
    if(!info) return;
    product(info.handle).then(function(p){
      var url = pick(p, info.variant, primary.currentSrc || primary.src);
      if(!url) return; /* kun ét billede: ingenting sker */
      var host = primary.parentElement;
      var cs = getComputedStyle(host);
      if(cs.position === 'static') host.style.position = 'relative';
      if(cs.display === 'inline') host.style.display = 'block';
      var img = document.createElement('img');
      img.className = 'product-item-image--secondary tosti-hover-img';
      img.alt = '';
      img.setAttribute('aria-hidden', 'true');
      img.decoding = 'async';
      img.onload = function(){ img.classList.add('is-ready'); };
      img.src = sized(url);
      host.appendChild(img);
    });
  }
  function onOver(e){
    var wrap = e.target.closest && e.target.closest('.product-item__image-wrapper, .tosti-card-img');
    if(wrap) attach(wrap);
  }
  if(canHover) document.addEventListener('mouseover', onOver, {passive:true});
})();
